<template>
  <div>
    <a-drawer
        :title='title'
        :visible="visible"
        v-bind="drawerConfig"
        :body-style="{ paddingBottom: '80px' }"
        @close="close">
      <a-checkbox v-model="checkAll" @change="handleCheckAllChange">
        全选
      </a-checkbox>
      <a-tree
          v-model="formData.menu_ids"
          checkable
          :expanded-keys="expandedKeys"
          :auto-expand-parent="autoExpandParent"
          :replaceFields="replaceFields"
          :selected-keys="selectedKeys"
          :tree-data="treeData"
          @expand="onExpand"
          @check="onCheck"
      />
      <div class="drawer-btn">
        <a-button type="primary" @click="handleSubmit" :style="{ marginRight: '8px' }">
          确定
        </a-button>
        <a-button @click="close">
          取消
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import {drawerConfig} from "@/utils/utils"
import API from "./api";

export default {
  name: "pagePermissionsSet",
  props: [],
  data() {
    return {
      drawerConfig,
      title: '权限设置',
      visible: false,
      treeData: [],
      checkAll: false,
      replaceFields: {children: 'children', title: 'label', key: 'id'},
      expandedKeys: [],
      autoExpandParent: true,
      selectedKeys: [],
      ids: [],
      idsArr: [],
      formData: {
        role_id: "",
        menu_ids: []
      }
    };
  },
  watch: {},
  mounted() {
  },
  methods: {
    handleSubmit() {
      let _this = this;
      API.service.RULE_POST({
        ...this.formData,
        menu_ids: this.idsArr
      }).then(res => {
        if (res.data.code == 200) {
          this.$message.success({content: res.data.msg, duration: 2})
          this.close()
          this.$emit("submitSuccess");
        } else if (res.data.code == 400) {
          res.data.msg.map((item) => {
            _this.formErr[item.field] = item.msg
          })
        }
      })
    },
    getInfo(data) {
      this.title = data.name + '-权限设置'
      API.service.RULE({
        role_id: data.id,
      }).then(res => {
        if (res.data.code == 1) {
          this.treeData = this.setTreeLabel(res.data.data.menu_list);
          this.ids = this.getIdsArr(res.data.data.menu_list)
          this.idsArr = res.data.data.checked_menu_ids
          this.formData = {
            role_id: data.id,
            menu_ids: this.getCheckedIds(this.treeData)
          }
          this.getCheckAllStatus()
        }
      })
    },
    getCheckedIds(list) {
      let ids = [];
      list.forEach((item) => {
        if (item.checked && !item.children) {
          ids.push(item.id);
        }
        if (item.children && item.children.length) {
          ids = ids.concat(this.getCheckedIds(item.children));
        }
      });
      return ids;
    },
    getIdsArr(list) {
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
        if (item.children && item.children.length) {
          ids = ids.concat(this.getIdsArr(item.children));
        }
      });
      return ids;
    },
    setTreeLabel(list) {
      return list.map((item) => {
        item.label = item.name + ' (' + (item.component_type || '') + ')';
        if (item.children && item.children.length) {
          item.children = this.setTreeLabel(item.children);
        }
        return item;
      });
    },
    handleCheckAllChange() {
      if (this.checkAll) {
        this.formData.menu_ids = this.ids
        this.idsArr = this.ids
      } else {
        this.formData.menu_ids = []
        this.idsArr = []
      }
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    getCheckAllStatus() {
      if (this.idsArr.length == this.ids.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    onCheck(checkedKeys, e) {
      this.idsArr = [...checkedKeys, ...e.halfCheckedKeys]
      console.log(this.idsArr)
      this.formData.menu_ids = checkedKeys;
      this.getCheckAllStatus()
    },
    open(data) {
      this.visible = true;
      this.getInfo(data)
    },
    close() {
      this.visible = false;
      this.formData = {
        role_id: "",
        menu_ids: []
      };
    }
  },
}
</script>

<style scoped>

</style>
